var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_vm._m(0),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"w-1200 clearfix"},[_c('div',{staticClass:"bgc-c"},[_c('img',{attrs:{"src":require("../assets/404.png")}}),_c('p',{staticClass:"p-t"},[_vm._v("您所访问的页面不存在")]),_c('p',{staticClass:"p-c"},[_vm._v(" 将在 "),_c('span',[_vm._v("3S")]),_vm._v(" 秒后为您跳转到首页 ")])])])])
}]

export { render, staticRenderFns }